/* eslint-disable @typescript-eslint/no-explicit-any */

var mobile = {
  rows: '1fr 7fr 56px 56px',
  columns: 'auto',
  area: "\n\"header \"\n\"main\"\n\"sidebar\"\n\"footer\"\n"
};
var tablet = {
  rows: '10% auto auto 10%',
  columns: '10% auto auto auto',
  area: "\n\"header header header header\"\n\"sidebar main main main\"\n\"sidebar main main main\"\n\"footer footer footer footer\"\n"
};
var desktop = {
  rows: '10% auto 10%',
  columns: '10% auto auto auto auto',
  area: "\n\"header header header header header\"\n\"sidebar main main main aside\"\n\"footer footer footer footer footer\"\n"
};
var grids = {
  sample: {
    gap: ['xxs', 'xs', 'sm', 'md', 'lg'],
    bg: 'yellow.5',
    height: '100vh',
    gridTemplateColumns: [mobile.columns, tablet.columns, null, desktop.columns],
    gridTemplateRows: [mobile.rows, tablet.rows, null, desktop.rows],
    gridTemplateAreas: [mobile.area, tablet.area, null, desktop.area]
  },
  peerDetail: {
    border: '3px dotted red',
    padding: '3px',
    gap: '3px',
    gridTemplate: "\n    \"nav header\" min-content\n    \"nav main\" 1fr\n        / min-content 1fr;\n    "
  }
};

export { grids };
//# sourceMappingURL=grids.esm.js.map
